import React from 'react';
import { graphql, withApollo } from 'react-apollo';
import FormCargarStock from './FormCargarStock';
import { notification, Modal } from 'antd/lib';
import insertAltaStock from '../../../graphql/mutations/venta/insertAltaStock.graphql';
import Loading from '../../common/Loading';

@graphql(insertAltaStock, {
  name: 'insertAltaStock',
})
class CargarStock extends React.Component {
  state = {
    loading: false,
  };

  onSubmit = values => {
    this.setState({
      loading: true,
    });

    this.props
      .insertAltaStock({
        variables: {
          objAltaStock: values,
        },
      })
      .then(res => {
        this.setState({
          loading: false,
        });

        if (res.data.insertAltaStock._id) {
          notification.success({
            message: 'Alta Stock Registrado',
            description: 'Se registro correctamente en la base de datos.',
          });
          this.props.history.push('/');
        }
      })
      .catch(err => {
        console.log('Existio un error a la hora de crear el alta de stock');
        console.log(err);

        Modal.error({
          title: 'Error en la creacion del alta de stock',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <br />
        <FormCargarStock opcionRender={1} onSubmit={this.onSubmit} />
      </div>
    );
  }
}

export default withApollo(CargarStock);
